import styled from '@emotion/styled';

export const RefreshButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  fontsize: 14px;
  display: flex;
  alignitems: center;
  gap: 5px;
  color: blue;
  margin-top: 5px;
`;

export const PayoutsDisabledMerchantsHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
